export default "__VITE_ASSET__CEO9gNM9__"